<template>
	<div class="report-title" pdf-truncation-check-point>
		<div class="title-header">
			<img src="../icons/img-business.png" alt="Logo" class="logo" />
			<h1>物联网平台监测{{ typeMap[type] }}</h1>
			<h2>{{ subtitle }}</h2>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ReportTitle',
	props: {
		type: {
			type: Number,
			default: null,
		},
		date: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			typeMap: {
				1: '月报',
				2: '季报',
				3: '年报',
			},
			quarterMap: {
				1: '一',
				2: '二',
				3: '三',
				4: '四',
			},
		}
	},
	computed: {
		subtitle() {
			if (!this.date) {
				return ''
			}
			const date = new Date(this.date)
			if (this.type === 1) {
				return `${date.getFullYear()}年${date.getMonth() + 1}月`
			} else if (this.type === 2) {
				const month = date.getMonth() + 1
				const quarter = Math.ceil(month / 3)
				return `${date.getFullYear()}年${this.quarterMap[quarter]}季度`
			} else if (this.type === 3) {
				return `${date.getFullYear()}年度`
			}
			return ''
		},
	},
}
</script>

<style lang="scss" scoped>
.report-title {
	text-align: left;
	margin-bottom: var(--report-grid-gap);
	padding: 15px;
	position: relative;
	background: #cbd8ff;
	border-radius: 8px;

	.title-header {
		display: flex;
		align-items: center;
		margin-bottom: 0;
		gap: 15px;

		.logo {
			height: 50px;
		}
	}

	h1 {
		font-size: 21px;
		font-weight: bold;
		color: #333333;
		margin: 0;
	}

	h2 {
		font-size: 14px;
		font-weight: 600;
		color: #4c6bff;
		padding: 4px 10px;
		background: #f9faff;
		border-radius: 4px;
	}
}
</style>
